import { FormattedMessage } from 'react-intl';

import config from '@/config';
import { IconType } from '@/modules/ui';
import { hasWritePermission } from '@/utilities/permission';

import { ListItemType, SecurityLeaks, UP_TO_LEAKS } from '../../constants';
import type { SecurityAuditLeaksItem } from '../../types';
import { IgnoreIndicator } from '../IgnoreIndicator';
import { SecurityAuditGroupItem } from '../SecurityAuditGroupItem';
import { SecurityAuditItemRenderer, type SecurityAuditItemRendererProps } from '../SecurityAuditItemRenderer';
import { SecurityAuditSecretItem } from '../SecurityAuditSecretItem';

export interface SecurityAuditLeaksItemRendererProps extends Omit<SecurityAuditItemRendererProps<SecurityAuditLeaksItem>, 'children'> {}

export const SecurityAuditLeaksItemRenderer = (props: SecurityAuditLeaksItemRendererProps) => (
    <SecurityAuditItemRenderer<SecurityAuditLeaksItem> {...props}>
        {({ item, isFirstGroup, isLastInGroup }) => (
            <>
                {item.listItemType === ListItemType.GROUP ? (
                    <SecurityAuditGroupItem
                        name={
                            <FormattedMessage
                                id={`password.leaks.${item.securityLeaks}`}
                                values={{
                                    upToLeaks: UP_TO_LEAKS,
                                }}
                            />
                        }
                        count={item.count}
                        isFirstGroup={isFirstGroup}
                    />
                ) : (
                    <SecurityAuditSecretItem
                        id={item.id}
                        name={item.name}
                        canEdit={hasWritePermission(item.userPermissions)}
                        icon={
                            item.securityLeaks === SecurityLeaks.MANY_LEAKS && !item.ignoreSecurityReport
                                ? IconType.STATUS_WARNING
                                : undefined
                        }
                        isLastInGroup={isLastInGroup}
                        updateSecretRoute={config.routes.securityAuditLeaksUpdateSecret}
                        additional={item.ignoreSecurityReport ? <IgnoreIndicator /> : null}
                    />
                )}
            </>
        )}
    </SecurityAuditItemRenderer>
);
